export const validateHelpDesk = (values, { t }) => {
  let errors = {};
  ['title', 'message'].forEach(element => {
    let value = values[element];
    if (
      value === undefined ||
      value === null ||
      value === {} ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      errors[element] = t`candidate:form.validation.nonEmpty`;
    }
  });

  return errors;
};

export default validateHelpDesk;
